<template>
    <div>
        <v-banner single-line sticky>
            <v-row>
                <v-col>
                    <v-btn
                        color="grey darken-1"
                        dark
                        fab
                        small
                        class="elevation-4"
                        :to="
                            '/Project/ViewCasepending/Bkk/' +
                                $route.params.caseid +
                                '/ViewDetail'
                        "
                    >
                        <v-icon>mdi-reply</v-icon>
                    </v-btn>
                </v-col>
                <v-col>
                    <h3 class="pb-2">
                        EDIT CASE | CASEID :
                        {{ showdata.caseid }} | PROJECT : {{ showdata.project }}
                    </h3>
                </v-col>
            </v-row>
        </v-banner>
        <br />
        <v-card>
            <v-information :condition="condition" :information="information" />
            <!-- <case-information :condition="condition" :information="information" />
      <product-information :information="information" />
      <customer-information :information="information" /> -->
            <engineer-information
                :condition="condition"
                :information="information"
            />
            <part-information
                :condition="condition"
                :information="information"
            />

            <v-row justify="center">
                <v-col cols="10" md="3" class="text-center">
                    <v-checkbox
                        v-if="condition.team != 'NONHP'"
                        v-model="information.skip_ismart"
                        false-value="N"
                        true-value="Y"
                        label="ช่างไม่ต้องปิด EEG"
                    ></v-checkbox>
                </v-col>
            </v-row>
            <v-row justify="center">
                <v-btn @click="saveCase()" class="ma-4" tile color="success">
                    <v-icon left>mdi-content-save</v-icon>Save
                </v-btn>
                <!-- <v-btn class="ma-4" tile color="warning">
                        <v-icon left>mdi-close-octagon</v-icon>
                        Cancel
        </v-btn>-->
            </v-row>
        </v-card>
    </div>
</template>
<script>
import axios from "axios"

import CaseInformation from "../components/CaseInformation"
import ProductInformation from "../components/ProductInformation"
import CustomerInformation from "../components/CustomerInformation"
import EngineerInformation from "../components/EngineerInformation"
import PartInformation from "../components/HpiPartInformation"
import LogInformation from "../components/LogInformation"

import Information from "../components/Information"
import EngineerNewInformation from "../components/EngineerNewInformation"
export default {
    components: {
        "case-information": CaseInformation,
        "customer-information": CustomerInformation,
        "product-information": ProductInformation,
        "engineer-information": EngineerNewInformation,
        "part-information": PartInformation,
        "log-information": LogInformation,
        "v-information": Information,
    },
    beforeMount() {
        this.getDetailNew()
    },
    // mounted() {
    //   this.getDetail();
    // },
    data() {
        return {
            closeOnClick: false,
            showdata: {
                caseid: "",
                project: "",
            },
            condition: {
                status: "editcase",
                team: "Bkk",
            },
            information: [],
            options: {
                offset: 100,
            },
            lists: [
                {
                    eleId: "#case",
                    eleName: "Case Information",
                },
                {
                    eleId: "#product",
                    eleName: "Products Information",
                },
                {
                    eleId: "#customer",
                    eleName: "Customer Information",
                },
                {
                    eleId: "#lognote",
                    eleName: "Log Note",
                },
                {
                    eleId: "#attach",
                    eleName: "Attachments",
                },
                {
                    eleId: "#parts",
                    eleName: "Parts Information",
                },
                {
                    eleId: "#services",
                    eleName: "Services Information",
                },
                {
                    eleId: "#happycall",
                    eleName: "Happy Call",
                },
                {
                    eleId: "#performance",
                    eleName: "Performance",
                },
            ],
        }
    },
    methods: {
        async saveCase() {
            // Start EEG --
            let check_status_part
            // this.dialog_loading = true

            console.log(this.information)

            this.information.part.map((each) => {
                if (each.status == "Back Order") {
                    check_status_part = "Back Order"
                }
            })
            this.information.check_status_part = check_status_part

            // if (
            //     this.information.check_status_part == "Back Order" &&
            //     this.information.skip_ismart == "N" &&
            //     this.information.project_name == "CDAX"
            // ) {
            //     let date = new Date()
            //     let year = date.toLocaleString("default", { year: "numeric" })
            //     let month = date.toLocaleString("default", { month: "2-digit" })
            //     let day = date.toLocaleString("default", { day: "2-digit" })
            //     var h = date.getHours()
            //     var m = date.getMinutes()
            //     var s = date.getSeconds()
            //     let formattedDate =
            //         year + "-" + month + "-" + day + "T" + h + ":" + m + ":" + s

            //     let Partner_Parts_Hold = {
            //         CaseExchange: {
            //             EventType: "PartnerUpdates",
            //             EventSubType: "Updates",
            //             Originator: "EEG_qASi4aFrltEdrAvEJI7raTLrLswa",
            //             IncomingChannel: "EEG",

            //             WorkOrder: {
            //                 WorkOrderID: this.information.wonumber,
            //                 PartnerName: "APJ_Acacia_P",
            //                 PartnerStatus: "Partner Parts Hold",
            //                 PartnerStatusDateTime: formattedDate,
            //             },
            //             Notes: {
            //                 NotesDescription: "$#Part Waiting#$",
            //                 ExternallyVisible: "Yes",
            //             },
            //         },
            //     }

            //     this.information.eeg = {
            //         Partner_Parts_Hold: Partner_Parts_Hold,
            //     }
            // }
            // END EEG --

            this.information.case_sla_datetime =
                this.information.case_sla_date +
                " " +
                this.information.case_sla_time
            const url = `${process.env.VUE_APP_ROOT_API}/api/hp/edit-case/${this.$route.params.caseid}/${this.information.subcase}`

            const options = {
                headers: {
                    Authorization: "Bearer " + localStorage.token,
                },
            }
            try {
                console.log(this.information, "-- Save Edit Case")
                let { data, status } = await axios.post(
                    url,
                    this.information,
                    options
                )
                if (status == "200") {
                    this.$swal({
                        title: "บันทึกข้อมูลเรียบร้อย",
                        icon: "success",
                        timer: 2000,
                    }).then((del) => {
                        let url =
                            "/Project/ViewCasepending/Bkk/" +
                            this.$route.params.caseid +
                            "/ViewDetail"
                        this.$router.push(url)
                    })
                }
            } catch (error) {
                console.log(error.message)
            }
        },
        async getDetailNew() {
            const url = `${process.env.VUE_APP_ROOT_API}/api/edit-case/${this.$route.params.caseid}/${this.$route.params.subcase}`
            try {
                const { data } = await axios.get(`${url}`)

                var part = []
                console.log(data.parts)
                data.parts.map((res) => {
                    part.push({
                        part_issue_id: res.part_issue_id,
                        ponumber: res.ponumber,
                        part_no: res.part_name,
                        part_desc: res.part_description,
                        rma: res.rma,
                        dateorder: "",
                        dateship: "",
                        status: res.status,
                        remark: res.remark,
                        ce_status: res.ce_status,
                        required_uefi: res.required_uefi,
                        extended_date: res.extended_date,
                        rf_name: res.rf_name,
                        subcase: res.subcase,
                        ponumber_line: res.ponumber_line,
                        eta: res.eta,
                    })
                })

                this.information = {
                    problem_type: [
                        { problem_type_name: "Hardware", problem_type_id: "4" },
                        { problem_type_name: "Software", problem_type_id: "5" },
                        {
                            problem_type_name: "Monitor",
                            problem_type_id: "13",
                        },
                        {
                            problem_type_name: "Toner",
                            problem_type_id: "3",
                        },
                    ],
                    part:
                        part.length != 0
                            ? [...part]
                            : [
                                  {
                                      part_issue_id: "",
                                      ponumber: "",
                                      part_no: "",
                                      part_desc: "",
                                      rma: "",
                                      dateorder: "",
                                      dateship: "",
                                      status: "",
                                      remark: "",
                                      ce_status: "",
                                  },
                              ],
                    ...data,
                }

                this.showdata.caseid = this.information.case_id
                this.showdata.project = this.information.project_name
                this.condition.project = this.information.project_name
            } catch (error) {
                console.log(error)
            }
        },
        gotoLink(eleId) {
            this.$vuetify.goTo(eleId, this.options)
        },
    },
}
</script>
